/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceInventoryResourceText extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceInventoryResourceText");
    }

    getFixupPrototypeFunction() { return ResourceInventoryResourceText.fixupPrototype; }

    static newInstance(model: Partial<ResourceInventoryResourceText>): ResourceInventoryResourceText {
        let obj = Object.assign(new ResourceInventoryResourceText(), model);
        ResourceInventoryResourceText.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceInventoryResourceText>): ResourceInventoryResourceText {
        if (!model) return null;
        return ResourceInventoryResourceText.newInstance(<ResourceInventoryResourceText> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceInventoryResourceText) {
        if (!obj) return;

        models.ResourceInventoryResourceText.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceInventoryResourceText): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceInventoryResourceText.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Optional search on resource id, name, location, resource group, category, resource type or resource
     */
    search: string;

}
